import styled from 'styled-components';

export const GraphArea = styled.div`
  width: 100%;
  flex-grow: 1;
`;
